const LOGIN = {
  init: () => {
    const $registerUrl = $('.register__url');
    $registerUrl.on('click', navigateToRegister);

    const passwordResetLink = document.getElementById('passwordreset-link');
    if (passwordResetLink !== null) {
      passwordResetLink.addEventListener('click', onResetPasswordClick);
    }
  },
};

const onResetPasswordClick = (event) => {
  event.currentTarget.removeEventListener('click', onResetPasswordClick);
  handleResetPasswordViaKeycloak(event);
};

const handleResetPasswordViaKeycloak = (event) => {
  let parametersList = [];

  addRequestParameter(
    parametersList,
    'email',
    encodeURIComponent(readCustomerEmail())
  );
  addRequestParameter(
    parametersList,
    'back_uri',
    window.encodedOriginalRequest
  );
  addRequestParameter(
    parametersList,
    'redirect_uri',
    window.encodedOriginalRequest
  );
  addRequestParameter(
    parametersList,
    'client_id',
    window.keycloakPasswordIntegrationClientId
  );
  addRequestParameter(parametersList, 'ui_locales', window.isoLocale);

  event.target.href = buildFullUrl(
    window.keycloakPasswordIntegrationUrl,
    parametersList
  );
};

const readCustomerEmail = () => {
  return document.getElementById('customerEmail').value;
};

const addRequestParameter = (parametersList, key, value) => {
  if (value !== undefined && value !== '') {
    parametersList.push(key + '=' + value);
  }
};

const buildFullUrl = (baseUrl, parametersList) => {
  let parametersPath = parametersList.join('&');
  if (parametersPath) {
    return baseUrl + '?' + parametersPath;
  }
  return baseUrl;
};

const navigateToRegister = () => {
  localStorage.setItem('checkoutLoginView', 'registration');
  location.href = '/checkout/register';
};
export default LOGIN;
